<template>
  <transition :name="transitionName">
    <div class="page-component-up" v-show="visible">
      <div class="background">
        <div class="qrocdeIcon" v-on:mouseenter="onMouserOfficialEnter" v-on:mouseleave="onMouserOfficialLevel">
          <i class="qrocde fa-chevron-up" aria-hidden="true"></i>
          <div class="backToFont">嗨浪公众号</div>
          <!-- 嗨浪公众号 -->
          <div class="official" v-if="officialModal">
            <div>
              <img src="../assets/hailangOffiicial.jpg" />
            </div>
            <div>
              <img src="../assets/wifiOfficial.jpg" />
            </div>
          </div>
        </div>
        <div class="contantIcon" v-on:mouseenter="onMouserEnter" v-on:mouseleave="onMouserLevel">
          <i class="contant fa-chevron-up" aria-hidden="true"></i>
          <div class="backToFont">联系我们</div>
          <!-- 联系我们 -->
          <div class="linkUs" v-if="contantUsModal">
            <div style="margin-top: 5px;">联系我们</div>
            <div>4000-8000-11</div>
          </div>
        </div>
        <div class="backToIcon" @click="backToTop">
          <i class="backTo fa-chevron-up" aria-hidden="true"></i>
          <div class="backToFont">返回顶部</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    transitionName: {
      type: String,
      default: 'fade'
    },
    visibilityHeight: { // 纵向滑动多远距离出现滚动条
      type: Number
    },
    backPosition: { // 返回顶部时，滚动到哪里（距离顶部的距离）
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      interval: null,
      contantUsModal: false, //联系我们
      officialModal: false //嗨浪公众号
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
    },
    backToTop() {
      let distanceY = window.pageYOffset
      let i = 0
      this.interval = setInterval(() => {
        let next = Math.floor(this.easeInOutQuad(10 * i, distanceY, -distanceY, 500))
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
        } else {
          window.scrollTo(0, next)
        }
        i++
      }, 17)
    },
    easeInOutQuad(t, b, c, d) {
      // 判断当前时间是否总在总时间的一半以内，是的话执行缓入函数，否则的话执行缓出函数
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t + b
      } else {
        // 将总长度设置为一半，并且时间从当前开始递减，对图像进行垂直向上平移
        return -c / 2 * (--t * (t - 2) - 1) + b
      }
    },
    // 嗨浪公众号鼠标移入事件
    onMouserOfficialEnter() {
      this.officialModal = true
    },
    // 嗨浪公众号鼠标移出事件
    onMouserOfficialLevel() {
      this.officialModal = false
    },
    // 联系我们鼠标移入事件
    onMouserEnter() {
      this.contantUsModal = true
    },
    // 联系我们鼠标移出事件
    onMouserLevel() {
      this.contantUsModal = false
    }
  }
}
</script>

<style scoped>
.page-component-up {
  position: fixed;
  right: 30px;
  bottom: 15px;
  display: flex;
  cursor: pointer;
  text-align: center;
  transition: .3s;
  z-index: 99;
}

.background {
  background: #fff;
  border-radius: 8px;
  filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, .1));
  padding: 20px;
}

.qrocdeIcon:hover {
  color: #0066FF;
}

.qrocde {
  background: url("../assets/icon/1.png") no-repeat center;
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 10px;
}

.qrocde:hover {
  background: url("../assets/icon/1.1.png") no-repeat center;
}

.contantIcon:hover {
  color: #0066FF;
}

.contant {
  background: url("../assets/icon/2.png") no-repeat center;
  width: 40px;
  height: 40px;
  display: block;
  margin-top: 20px;
  margin-left: 10px;
}

.official {
  width: 300px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: absolute;
  right: 100px;
  top: 0px;
  background-color: #ffffff;
  transition: all 0.5s;
  display: flex;
}

.linkUs {
  width: 120px;
  height: 80px;
  line-height: 35px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: absolute;
  right: 100px;
  top: 90px;
  background-color: #ffffff;
  transition: all 0.5s;
}

.contant:hover {
  background: url("../assets/icon/2.1.png") no-repeat center;
}

.backToIcon:hover {
  color: #0066FF;
}

.backTo {
  background: url("../assets/icon/3.png") no-repeat center;
  width: 40px;
  height: 40px;
  display: block;
  margin-top: 20px;
  margin-left: 10px;
}

.backTo:hover {
  background: url("../assets/icon/3.1.png") no-repeat center;
}

.backToFont {
  font-size: 12px;
  margin-top: 10px;
}
</style>